/**
 * Bin envanter sınıfları — API sözleşmesi (bkz. ADR-0009).
 *
 * Stok konumu döndüren her satırda `binScope` gelir. Envanter dışı ve akış
 * stoğu gizlenmez, ayrı başlıklar altında gösterilir. Tanınmayan bir değer
 * envanter sayılır — yeni bir scope eklenirse ekran patlamaz.
 */

export type BinScope = 'inventory' | 'non_inventory' | 'flow_in' | 'flow_out';

export interface ScopedRow {
  binScope?: string;
}

export const SCOPE_SECTIONS: { scope: BinScope; label: string }[] = [
  { scope: 'non_inventory', label: 'Envanter dışı' },
  { scope: 'flow_in', label: 'Yolda · Mal kabul' },
  { scope: 'flow_out', label: 'Yolda · Sevkiyat' },
];

const SECTION_SCOPES = new Set<string>(SCOPE_SECTIONS.map(s => s.scope));

/** Envanter satırları ile envanter dışı/akış bölümlerini ayırır. */
export function groupByScope<T extends ScopedRow>(rows: T[]): {
  inventory: T[];
  sections: { scope: BinScope; label: string; rows: T[] }[];
} {
  return {
    inventory: rows.filter(r => !r.binScope || !SECTION_SCOPES.has(r.binScope)),
    sections: SCOPE_SECTIONS
      .map(s => ({ ...s, rows: rows.filter(r => r.binScope === s.scope) }))
      .filter(s => s.rows.length > 0),
  };
}

/** Toplamlara yalnızca Envanter Bin'leri girer (bkz. ADR-0009). */
export function isInventoryScope(scope?: string): boolean {
  return !scope || !SECTION_SCOPES.has(scope);
}
